import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { readStoredUser } from "../../../utils/sessionUser";
import OriginalDocumentViewer from "./OriginalDocumentViewer";
import { viewFromSearch } from "./originalViewerState";

export default function OriginalDocumentPage() {
  const { id } = useParams();
  const { search } = useLocation();
  const [original] = useState(() => {
    const query = new URLSearchParams(search);
    return { id, documentType: ["supplier-invoice", "invoice-delivery-note"].includes(query.get("document_type")) ? query.get("document_type") : undefined, invoiceId: query.get("invoice_id"), name: query.get("name"), businessUnitId: Number(query.get("business_unit_id")), userId: readStoredUser()?.id };
  });
  return <main className="original-standalone">
    <OriginalDocumentViewer original={original} initialView={viewFromSearch(search)} standalone />
  </main>;
}
